<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button data-cy="close-modal-btn" (click)="dismissModal(false)">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      *ngIf="
        platformService?.platformType !== platformService?.platformEnum?.mobile
      "
      >{{ 'i18n.orderSubmittedPage.shipToModal.shipTo' | translate }}</ion-label
    >
    <div
      class="section-header-mobile"
      *ngIf="
        platformService?.platformType === platformService?.platformEnum?.mobile
      "
    >
      <ion-back-button
        *ngIf="currentStep !== 1"
        text=""
        icon="chevron-back-outline"
        (click)="currentStep = currentStep - 1"
      >
        <!-- <ion-icon name="chevron-back-outline" class="chevron"></ion-icon> -->
      </ion-back-button>
      <ion-label>{{ stepNameMobile | translate }}</ion-label>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
  tabletTouchMove
>
  <ion-grid>
    <ion-row>
      <!-- Ship To Step Options -->
      <ion-col
        size="4.5"
        *ngIf="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
        "
      >
        <ion-list>
          <ion-item
            class="clickable"
            [ngClass]="currentStep === 1 ? 'selected' : ''"
            (click)="currentStep = 1"
            detail
          >
            <ion-label>
              {{ 'i18n.orderSubmittedPage.shipToModal.step1' | translate }}
              <br />
              <span>
                {{ currentSelections?.customer?.customerName | titlecase }}
                <ng-container *ngIf="currentSelections?.isCustomerSelected"
                  >({{ currentSelections?.customer?.customerNumber }})<span
                    *ngIf="!!currentSelections?.department"
                  >
                    ({{
                      currentSelections?.department?.departmentNumber
                    }})</span
                  ></ng-container
                >
              </span>
            </ion-label>
          </ion-item>
          <ion-item
            class="clickable"
            [ngClass]="currentStep === 2 ? 'selected' : ''"
            detail
            (click)="
              currentStep === 1 ? proceedToNextStep() : (currentStep = 2)
            "
          >
            <ion-label>
              {{ 'i18n.orderSubmittedPage.shipToModal.step2' | translate }}
              <br />
              <span>{{
                !!currentSelections?.updatedDeliveryDate
                  ? (currentSelections.updatedDeliveryDate | date: 'MM/dd/yyyy')
                  : (currentDeliveryDate | date: 'MM/dd/yyyy')
              }}</span>
            </ion-label>
          </ion-item>

          <ion-item
            class="clickable"
            [ngClass]="currentStep === 3 ? 'selected' : ''"
            detail
            (click)="currentStep === 2 ? proceedToNextStep() : null"
          >
            <ion-label>
              {{ 'i18n.orderSubmittedPage.shipToModal.step3' | translate }}
              <br />
              <span>{{
                'i18n.orderSubmittedPage.shipToModal.opt' | translate
              }}</span>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-col>
      <!-- Step Selections -->
      <ion-col
        size-xl="7"
        offset-xl=".5"
        size-lg="7"
        offset-lg=".5"
        size-md="7"
        offset-md=".5"
        size-xs="12"
        offset-xs="0"
        size-sm="12"
        offset-sm="0"
      >
        <!-- Customers -->
        <div id="customer-selection-section" *ngIf="currentStep === 1">
          <ion-label
            class="select-customer-label"
            *ngIf="
              platformService?.platformType ===
              platformService?.platformEnum?.desktop
            "
            >{{ 'i18n.header.selectCustomer' | translate }}</ion-label
          >
          <ion-searchbar
            data-cy="ship-details-customer-searchbar"
            class="search"
            mode="md"
            placeholder="{{ 'i18n.common.searchCustomers' | translate }}"
            [(ngModel)]="searchKey"
            (ionClear)="resetSearch()"
            (ionInput)="!isSuperUser ? customerSearch() : null"
            (keyup.enter)="
              isSuperUser && searchKey.length > 2
                ? superUserCustomerSearch()
                : null
            "
          ></ion-searchbar>
          <ion-list class="customers-list">
            <ng-container
              *ngFor="
                let customer of !isSuperUser
                  ? filteredCustomerList
                  : (superUserCustomerListLoading$ | async) === false
                    ? (superUserCustomerList$
                      | async
                      | paginate
                        : {
                            itemsPerPage: 8,
                            currentPage,
                            totalItems: (superUserCustomerList$ | async).length,
                          })
                    : []
              "
            >
              <div class="no-results-found" *ngIf="customers?.length === 0">
                {{ 'i18n.lists.copyListModal.noResultsFound' | translate }}
              </div>
              <ion-item
                class="customer clickable"
                *ngIf="
                  !(
                    currentShipToCustomerNumber === customer?.customerNumber &&
                    customer?.departments?.length === 1
                  )
                "
              >
                <ng-container *ngIf="!customer.departments?.length; else label">
                  <ion-checkbox
                    data-cy="ship-details-customer-name-input"
                    mode="ios"
                    justify="space-between"
                    [checked]="
                      currentSelections?.isCustomerSelected &&
                      !!currentSelections?.customer &&
                      currentSelections?.customer?.customerNumber ===
                        customer?.customerNumber
                    "
                    (ionChange)="
                      isSuperUser
                        ? handleSuperUserCustomerSelection(
                            $event,
                            customer,
                            null
                          )
                        : handleCustomerSelection($event, customer, null)
                    "
                  >
                    <span class="customer-name-and-number">
                      {{ customer.customerName | titlecase }} ({{
                        customer.customerNumber
                      }})</span
                    ></ion-checkbox
                  ></ng-container
                >
                <ng-template #label
                  ><ion-label
                    >{{ customer.customerName | titlecase }} ({{
                      customer.customerNumber
                    }})</ion-label
                  ></ng-template
                >
              </ion-item>
              <ng-container *ngIf="!!customer.departments?.length">
                <ng-container *ngFor="let department of customer.departments">
                  <ion-item
                    data-cy="ship-details-department-name-text"
                    class="dept clickable"
                    *ngIf="
                      shouldDisplayCustomer(
                        customer?.customerNumber,
                        true,
                        department?.departmentNumber
                      )
                    "
                  >
                    <ion-checkbox
                      data-cy="ship-details-department-name-input"
                      mode="ios"
                      justify="space-between"
                      [checked]="
                        currentSelections?.isCustomerSelected &&
                        currentSelections?.customer?.customerNumber ===
                          customer?.customerNumber &&
                        currentSelections?.department?.departmentNumber?.toString() ===
                          department?.departmentNumber?.toString()
                      "
                      (ionChange)="
                        isSuperUser
                          ? handleSuperUserCustomerSelection(
                              $event,
                              customer,
                              department
                            )
                          : handleCustomerSelection(
                              $event,
                              customer,
                              department
                            )
                      "
                    >
                      <span class="department-name-and-number">
                        {{ department.departmentName | titlecase }} ({{
                          department.departmentNumber
                        }})</span
                      ></ion-checkbox
                    >
                  </ion-item>
                </ng-container>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!isSuperUser; else superUserLoading">
              <div
                data-cy="ship-details-no-customers-found-text"
                class="no-customers-found"
                *ngIf="filteredCustomerList?.length === 0"
              >
                {{ 'i18n.orderStatusPage.noCustomersFound' | translate }}
              </div>
            </ng-container>
            <ng-template #superUserLoading>
              <div
                data-cy="ship-details-no-customers-found-text"
                class="no-customers-found"
                *ngIf="searchKey.length > 2"
              >
                <ng-container
                  *ngIf="
                    (superUserCustomerList$ | async).length === 0 &&
                      (superUserCustomerListLoading$ | async) === false;
                    else loadingSpinner
                  "
                >
                  <ng-container *ngIf="superUserSearchPerformed === true">
                    {{
                      'i18n.orderStatusPage.noCustomersFound' | translate
                    }}</ng-container
                  >
                </ng-container>
                <ng-template #loadingSpinner>
                  <ion-spinner
                    name="circles"
                    class="customer-loading-spinner"
                    *ngIf="(superUserCustomerListLoading$ | async) === true"
                  ></ion-spinner>
                </ng-template></div
            ></ng-template>
          </ion-list>
        </div>
        <div class="pagination-controls-container">
          <pagination-controls
            *ngIf="
              (superUserCustomerList$ | async)?.length > 8 &&
              (superUserCustomerListLoading$ | async) === false &&
              currentStep === 1
            "
            data-cy="ship-to-modal-pagination-controls"
            class="pagination-controls"
            previousLabel=""
            nextLabel=""
            (pageChange)="changePage($event)"
          ></pagination-controls>
        </div>
        <!-- Delivery Selection -->
        <div *ngIf="currentStep === 2" id="delivery-selection-section">
          <div class="bold-font-weight">
            {{ 'i18n.orderSubmittedPage.shipToModal.deliveryDate' | translate
            }}<span>*</span>
          </div>
          <div *ngIf="showDeliveryDateChangedMessage === true">
            <span class="delivery-date-change-message">{{
              'i18n.orderSubmittedPage.shipToModal.deliveryDateChanged'
                | translate
            }}</span>
          </div>
          <div class="bold-font-weight date-selected">
            {{ 'i18n.orderSubmittedPage.shipToModal.dateSelected' | translate }}
            <span
              data-cy="ship-details-date-selected-text"
              class="regular-font-weight"
              >{{
                this.currentSelections.updatedDeliveryDate | date: 'MM/dd/yyyy'
              }}</span
            >
          </div>

          <ion-datetime
            data-cy="ship-details-delivery-calendar"
            presentation="date"
            mode="ios"
            size="cover"
            data-cy="delivery-date-calendar"
            [isDateEnabled]="isDateEnabled"
            [min]="currentSelections?.nextCustomerDeliveryDate"
            [max]="nextYear"
            [(ngModel)]="currentSelections.updatedDeliveryDate"
            (ionChange)="handleDateSelection($event)"
          >
          </ion-datetime>
        </div>

        <!-- Ship Details Selection -->
        <div *ngIf="currentStep === 3" id="ship-details-selection-section">
          <div class="step-3-customer-name">
            <span>
              {{ currentSelections?.customer?.customerName | titlecase }}
              <ng-container *ngIf="currentSelections?.isCustomerSelected"
                >({{ currentSelections?.customer?.customerNumber }})<span
                  *ngIf="!!currentSelections?.department"
                >
                  ({{ currentSelections?.department?.departmentNumber }})</span
                ></ng-container
              >
            </span>
          </div>

          <ion-label class="ship-details-step-3-label">{{
            'i18n.orderSubmittedPage.shipToModal.addlInstructions' | translate
          }}</ion-label>
          <div class="addtl-instructions-container">
            <ion-item class="ship-details-step-3-item">
              <ion-input
                data-cy="ship-details-addl-instructions-input"
                placement="floating"
                id="usf-line-input-style"
                maxlength="60"
                [ngModel]="currentSelections?.additionalDeliveryIntructions"
                (ionInput)="updateAddtlInstructions($event)"
              ></ion-input>
            </ion-item>
            <br />

            <span class="character-count" data-cy="addl-instructions-count"
              >{{
                !!currentSelections?.additionalDeliveryIntructions
                  ? currentSelections?.additionalDeliveryIntructions.length
                  : 0
              }}/60</span
            >
          </div>
          <ion-label class="ship-details-step-3-label">{{
            'i18n.orderSubmittedPage.shipToModal.custPO' | translate
          }}</ion-label>
          <ion-item class="ship-details-step-3-item">
            <ion-input
              data-cy="ship-details-customer-po-input"
              placement="floating"
              id="usf-line-input-style"
              [appRegexInputValidator]="poRegex"
              [ngModel]="currentSelections?.poNumber"
              (ionInput)="updatePoNumber($event)"
              maxLength="20"
            ></ion-input>
          </ion-item>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-footer-modal ion-footer-modal-desktop">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="clear-all-modal-btn"
        data-cy="clear-ship-filter-modal-btn"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismissModal(false)"
        translate
      >
        {{ 'i18n.common.cancel' }}
      </ion-button>
      <ion-button
        id="apply-modal-btn"
        data-cy="save-ship-filter-modal-btn"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="proceedToNextStep()"
        [disabled]="
          isNextButtonDisabled() ||
          (isSuperUser &&
            (isCustomerLoadingSuperUser || !checkedCustomerNumber))
        "
      >
        {{
          isSuperUser
            ? !isCustomerLoadingSuperUser
              ? currentStep === 3
                ? ('i18n.common.save' | translate)
                : ('i18n.common.next' | translate)
              : ('i18n.common.loading' | translate) + '...'
            : currentStep === 3
              ? ('i18n.common.save' | translate)
              : ('i18n.common.next' | translate)
        }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
